const todoNoteFilters = {
  todoId: null,
  createAt: null,
  createdBy: null
}

export default () => Object.assign({}, todoNoteFilters)
